<template>
  <LegalPage :title="title" :subtitle="subtitle">
    <template v-slot:sections>
      <div class="privacy-policy-content" v-if="privacyContent">
        <p v-if="privacyContent.lastUpdated" class="text-muted mb-4">
          <small>Stand: {{ privacyContent.lastUpdated }}</small>
        </p>
        <div
          v-for="section in privacyContent.sections"
          :key="section.id"
          class="mb-5"
        >
          <h2 class="h3 mb-4 text-success">{{ section.title }}</h2>
          
          <p v-if="section.content" class="mb-4">{{ section.content }}</p>
          
          <div 
            v-for="(subsection, index) in section.subsections" 
            :key="index"
            class="mb-4"
          >
            <h3 class="h5 mb-3 text-dark">{{ subsection.title }}</h3>
            
            <div v-if="subsection.content" class="mb-3">
              <p 
                v-for="(paragraph, pIndex) in subsection.content.split('\n\n')" 
                :key="pIndex"
                class="mb-2"
                :class="{ 
                  'alert alert-warning p-3': subsection.isImportant,
                  'fw-bold': subsection.isImportant 
                }"
              >
                {{ paragraph }}
              </p>
            </div>
            
            <!-- Questions and answers -->
            <div v-if="subsection.questions" class="mb-3">
              <div 
                v-for="(qa, qaIndex) in subsection.questions" 
                :key="qaIndex"
                class="mb-3"
              >
                <h6 class="fw-bold text-secondary mb-2">{{ qa.question }}</h6>
                <p 
                  v-for="(paragraph, pIndex) in qa.answer.split('\n\n')" 
                  :key="pIndex"
                  class="mb-2 ps-3"
                >
                  {{ paragraph }}
                </p>
              </div>
            </div>
            
            <ul v-if="subsection.list" class="mb-3">
              <li 
                v-for="(item, listIndex) in subsection.list" 
                :key="listIndex"
                class="mb-2"
              >
                {{ item }}
              </li>
            </ul>
            
            <p v-if="subsection.additionalContent" class="mb-3">
              {{ subsection.additionalContent }}
            </p>
          </div>
        </div>
        
        <div v-if="privacyContent.source" class="mt-5 pt-3 border-top text-muted">
          <p>
            {{ privacyContent.source.text }} 
            <a 
              :href="privacyContent.source.link" 
              target="_blank" 
              rel="noopener noreferrer"
              class="text-success"
            >
              {{ privacyContent.source.linkText }}
            </a>
          </p>
        </div>
      </div>
    </template>
  </LegalPage>
</template>

<script>
import LegalPage from '@/Layouts/LegalPageLayout.vue';
import { privacyPolicyContent } from '@/assets/privacy/privacyPolicyContent.js';


export default {
  name: 'PrivacyPolicyPage',
  components: {
    LegalPage
  },
  data() {
    return {
      title: 'Datenschutzerklärung',
      subtitle: 'Ihre Privatsphäre ist uns wichtig',
      privacyContent: privacyPolicyContent
    };
  }
}
</script>

<style scoped>
.privacy-policy-content {
  font-size: 1rem;
  line-height: 1.6;
}

.privacy-policy-content h2 {
  font-weight: 600;
  margin-top: 2rem;
}

.privacy-policy-content h3 {
  font-weight: 500;
}

.privacy-policy-content h6 {
  font-size: 1rem;
}

.privacy-policy-content p {
  text-align: justify;
}

.privacy-policy-content ul {
  padding-left: 1.5rem;
}

.privacy-policy-content li {
  text-align: justify;
}

.alert-warning {
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 0.5rem;
}

@media (max-width: 768px) {
  .privacy-policy-content {
    font-size: 0.95rem;
  }
  
  .privacy-policy-content p,
  .privacy-policy-content li {
    text-align: left;
  }
}
</style>